import { render, staticRenderFns } from "./CollectionTaskReopened.vue?vue&type=template&id=2f9302d7&scoped=true&"
import script from "./CollectionTaskReopened.vue?vue&type=script&lang=js&"
export * from "./CollectionTaskReopened.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9302d7",
  null
  
)

export default component.exports